import { render, staticRenderFns } from "./TruckStatusChart.vue?vue&type=template&id=52c79290&scoped=true&"
import script from "./TruckStatusChart.vue?vue&type=script&lang=js&"
export * from "./TruckStatusChart.vue?vue&type=script&lang=js&"
import style0 from "./TruckStatusChart.vue?vue&type=style&index=0&id=52c79290&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../DATA/projects/nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c79290",
  null
  
)

export default component.exports